import React from 'react';
import { PostModel } from '../../NewsfeedModels';
import { Text } from 'library';
import { Link } from 'react-router-dom';
import { track } from 'shared/Tracking';

export default function getUserName({ post }: { post: PostModel }) {
    const navigateToUserProfile = () => {
        track('Posts: Navigate To User Profile', { post });
    };
    if (post.user.role === 'PROVIDER') {
        return (
            <Link to={`/provider/${post.user.id}`} onClick={navigateToUserProfile}>
                <Text variant="body2" bold textStyle={{ textDecoration: 'underline' }}>
                    {post.user.first_name} {post.user.last_name_initial}
                </Text>
            </Link>
        );
    }

    const ActionText = () => {
        return (
            <Text variant="body2" bold>
                {post.content}
            </Text>
        );
    };

    return !!post.user.first_name && !!post.user.last_name_initial ? (
        <>
            {post.user_generated ? (
                <Text variant="body2" bold>
                    {`${post.user.first_name} ${post.user.role === 'TANDEM' ? '' : post.user.last_name_initial}`}
                </Text>
            ) : (
                <ActionText />
            )}
        </>
    ) : (
        <Text variant="deprecatedCaption">
            New Family in{' '}
            <Text variant="body2" bold>
                {post.user.address[0]?.city}, {post.user.address[0]?.state}
            </Text>
        </Text>
    );
}
